import Lottie from "lottie-react";
import { cn } from "@/app/shared/utils/utils";
import loadingAnimation from "@/app/shared/animations/loading-dots.json";

interface LoaderProps {
	className?: string;
	size?: "xs" | "sm" | "md" | "lg" | "xl";
}

const sizeMap = {
	xs: 20, // 20px - inline inside buttons / compact controls
	sm: 56, // 56px - inline/small contexts (increased by 75%)
	md: 84, // 84px - default, modals (increased by 75%)
	lg: 112, // 112px - full-page loading (increased by 75%)
	xl: 168, // 168px - splash screens (increased by 75%)
};

export function Loader({ className, size = "md" }: LoaderProps) {
	const dimension = sizeMap[size];

	return (
		<div className={cn("flex items-center justify-center", className)}>
			<Lottie
				animationData={loadingAnimation}
				loop
				style={{ width: dimension, height: dimension }}
			/>
		</div>
	);
}
